<template>
  <div class="sidearm-mm-game-stats flex flex-align-center h-100">
    <div class="sidearm-mm-game-stats__details col-3-of-8">
      <transition name="slide-fade" mode="out-in">
        <div v-if="active_tab === 0" key="0">
          <h2 class="type-hero">Team Matchup</h2>
          <p
            v-if="game.story && game.story.headline"
            class="type-paragraph-large"
          >
            {{ this.game.story.headline }}
          </p>
          <p v-else-if="!game.opponent" class="type-paragraph-large">
            Gameday: {{this.$root.data.team.seed ? "No. " + this.$root.data.team.seed : ""}}
            {{ this.$root.data.school.name }} will compete in the
            {{ round.title }}{{
              game.tbd ? "" : " on " + moment(game.date).format("MMM D, YYYY")
            }}.
          </p>
          <p v-else class="type-paragraph-large">
            Gameday: {{this.$root.data.team.seed ? "No. " + this.$root.data.team.seed : ""}}
            {{ this.$root.data.school.name }} will square off in the
            {{ round.title }} against{{
              game.opponent.seed ? " No. " + game.opponent.seed : ""
            }}
            {{ opponentName
            }}{{
              game.tbd ? "" : " on " + moment(game.date).format("MMM D, YYYY")
            }}.
          </p>
          <a
            :href="
              '/cumestats.aspx?path=' +
                this.$root.data.sport.sport_shortname +
                '&year=' +
                (this.$root.year - 1) +
                '-' +
                this.$root.year
            "
            target="_blank"
            class="sidearm-mm-btn --ghost"
            >Full Team Stats</a
          >
        </div>

        <div v-if="active_tab === 1" key="1">
          <h2 class="type-hero">Player Matchup</h2>
          <p v-if="!game.opponent" class="type-paragraph-large">
            Gameday: {{this.$root.data.team.seed ? "No. " + this.$root.data.team.seed : ""}}
            {{ this.$root.data.school.name }} will compete in the
            {{ round.title }}{{
              game.tbd ? "" : " on " + moment(game.date).format("MMM D, YYYY")
            }}.
          </p>
          <p v-else class="type-paragraph-large">
            Gameday: {{this.$root.data.team.seed ? "No. " + this.$root.data.team.seed : ""}}
            {{ this.$root.data.school.name }} will square off in the
            {{ round.title }} against{{
              game.opponent.seed ? " No. " + game.opponent.seed : ""
            }}
            {{ opponentName
            }}{{
              game.tbd ? "" : " on " + moment(game.date).format("MMM D, YYYY")
            }}.
          </p>
          <a
            :href="'/roster.aspx?sport_id=' + $root.data.sport.id"
            target="_blank"
            class="sidearm-mm-btn --ghost"
            >{{ $root.data.school.name }} Roster</a
          >
        </div>

        <div v-if="active_tab === 2" key="2">
          <h2 class="type-hero">Tournament History</h2>
          <p v-if="!game.opponent" class="type-paragraph-large">
            Gameday: {{this.$root.data.team.seed ? "No. " + this.$root.data.team.seed : ""}}
            {{ this.$root.data.school.name }} will compete in the
            {{ round.title }}{{
              game.tbd ? "" : " on " + moment(game.date).format("MMM D, YYYY")
            }}.
          </p>
          <p v-else class="type-paragraph-large">
            Gameday: {{this.$root.data.team.seed ? "No. " + this.$root.data.team.seed : ""}}
            {{ this.$root.data.school.name }} will square off in the
            {{ round.title }} against{{
              game.opponent.seed ? " No. " + game.opponent.seed : ""
            }}
            {{ opponentName
            }}{{
              game.tbd ? "" : " on " + moment(game.date).format("MMM D, YYYY")
            }}.
          </p>
        </div>
      </transition>
    </div>

    <div
      class="sidearm-mm-game-stats__tabs-container col-5-of-8 bg-white h-100 text-black"
    >
      <tabs
        v-model="active_tab"
        class="sidearm-mm-game-stats__tabs h-100 overflow-hidden flex flex-column"
      >
        <template v-slot:header>
          <div
            v-show="active_tab === 0 && round.opponent_stats && round.opponent_stats.team_stats"
            class="flex flex-justify-end flex-align-center"
          >
            <div
              class="sidearm-mm-game-stats__legend flex flex-align-center mr-2 py-1"
            >
              <img
                :src="$root.school_logo(36, 36)"
                :alt="
                  $root.data.school.name
                    ? $root.data.school.name
                    : 'School Logo'
                "
              />
              <span class="ml-2 sidearm-mm-game-stats__legend-key"></span>
            </div>
            <div class="sidearm-mm-game-stats__legend flex flex-align-center">
              <img
                :src="
                  round.game.opponent &&
                  round.game.opponent.image &&
                  round.game.opponent.image.url
                    ? `${$root.absolutize_cdn(
                        round.game.opponent.image.url
                      )}?width=36&height=36`
                    : `${$root.school_logo(36, 36)}&s.grayscale=100`
                "
                :alt="
                  round.game.opponent
                    ? round.game.opponent.title
                    : 'Opponent Logo'
                "
              />
              <span
                class="ml-2 sidearm-mm-game-stats__legend-key sidearm-mm-game-stats__legend-key--opponent"
              ></span>
            </div>
          </div>
          <div
            v-show="active_tab === 1 && opponent_roster_with_stats.length"
            class="flex flex-justify-end flex-align-center py-1"
          >
            <label for="team-stats" class="mr-2">
              <img
                :src="$root.school_logo(36, 36)"
                :alt="
                  $root.data.school.name
                    ? $root.data.school.name
                    : 'School Logo'
                "
              />
            </label>
            <input
              type="checkbox"
              id="team-stats"
              class="mr-2"
              v-model="include_team_in_player_stats"
            />
            <label for="opponent-stats" class="mr-2"
              ><img
                :src="
                  round.game.opponent &&
                  round.game.opponent.image &&
                  round.game.opponent.image.url
                    ? `${$root.absolutize_cdn(
                        round.game.opponent.image.url
                      )}?width=36&height=36`
                    : `${$root.school_logo(36, 36)}&s.grayscale=100`
                "
                :alt="
                  round.game.opponent
                    ? round.game.opponent.title
                    : 'Opponent Logo'
                "
            /></label>
            <input
              type="checkbox"
              id="opponent-stats"
              v-model="include_opponents_in_player_stats"
            />
          </div>
        </template>
        <tab name="Team Stats" key="0">
          <div v-set-normal-scroll class="h-100 overflow-auto">
            <div class="flex">
              <div
                v-if="$root.cumestats_overall"
                class="flex flex-column flex-align-center flex-justify-center text-center flex-item-1 pa-2 border-light-l"
              >
                <abbr
                  title="Field Goal Percentage"
                  class="mb-1 text-decoration-none border-none"
                  >FG%</abbr
                >

                <circle-chart
                  :percentage="
                    Number($root.cumestats_overall.our_field_goal_percentage) *
                      100
                  "
                />
              </div>

              <div
                v-if="round.opponent_stats.team_stats"
                class="flex flex-column flex-align-center flex-justify-center text-center flex-item-1 pa-2 border-light-l"
              >
                <abbr
                  title="Field Goal Percentage"
                  class="mb-1 text-decoration-none border-none"
                  >FG%</abbr
                >

                <circle-chart
                  :percentage="
                    Number(
                      round.opponent_stats.team_stats.our_field_goal_percentage
                    ) * 100
                  "
                  color="#D1D1D1"
                />
              </div>

              <div
                v-if="$root.cumestats_overall"
                class="flex flex-column flex-align-center flex-justify-center text-center flex-item-1 pa-2 border-light-l"
              >
                <abbr
                  title="3 Point Field Goal Percentage"
                  class="mb-1 text-decoration-none border-none"
                  >3PT%</abbr
                >

                <circle-chart
                  :percentage="
                    Number(
                      $root.cumestats_overall
                        .our_three_point_field_goal_percentage
                    ) * 100
                  "
                />
              </div>
              <div
                v-if="round.opponent_stats.team_stats"
                class="flex flex-column flex-align-center flex-justify-center text-center flex-item-1 pa-2 border-light-l"
              >
                <abbr
                  title="3 Point Field Goal Percentage"
                  class="mb-1 text-decoration-none border-none"
                  >3PT%</abbr
                >

                <circle-chart
                  :percentage="
                    Number(
                      round.opponent_stats.team_stats
                        .our_three_point_field_goal_percentage
                    ) * 100
                  "
                  color="#D1D1D1"
                />
              </div>

              <div
                v-if="$root.cumestats_overall"
                class="flex flex-column flex-align-center flex-justify-center text-center flex-item-1 pa-2 border-light-l"
              >
                <abbr
                  title="Free Throw Percentage"
                  class="mb-1 text-decoration-none border-none"
                  >FT%</abbr
                >

                <circle-chart
                  :percentage="
                    Number($root.cumestats_overall.our_free_throws_percentage) *
                      100
                  "
                />
              </div>
              <div
                v-if="round.opponent_stats.team_stats"
                class="flex flex-column flex-align-center flex-justify-center text-center flex-item-1 pa-2 border-light-l"
              >
                <abbr
                  title="Free Throw Percentage"
                  class="mb-1 text-decoration-none border-none"
                  >FT%</abbr
                >

                <circle-chart
                  :percentage="
                    Number(
                      round.opponent_stats.team_stats.our_free_throws_percentage
                    ) * 100
                  "
                  color="#D1D1D1"
                />
              </div>
            </div>

            <table class="sidearm-mm-table" :aria-label="`Statistics for ${schoolName} compared to ${opponentName}`">
              <caption class="sr-only">
                {{`Team Stats for ${schoolName} and ${opponentName}`}}
              </caption>
              <tr class="sr-only"> <!-- Add a visibly hidden but accessible header area -->
                <th id="stat" scope="col">Stat Name</th>
                <th id="team" scope="col">Team</th>
                <th id="number" scope="col">Numerical Statistic</th>
                <th id="progress" scope="col">Visual progress bar</th>
                <th id="success" scope="col">Team Success</th>
              </tr> 
              <tbody>
                <template v-for="stat in team_stats">
                  <tr :key="stat.title + '_team'" class="border-none">
                    <th
                      :rowspan="stat.opponent !== null ? 2 : 1"
                      scope="row"
                      class="border-light-b"
                    >
                      {{ stat.title }}
                    </th>
                    <th id="home" :rowspan="1" class="is-hidden">
                      {{ $root.data.school.name }}
                    </th>
                    <td headers="home number" class="no-padding border-light-b">{{ stat.team }}</td>
                    <td headers="home progress" class="no-padding w-40 border-light-b">
                      <meter
                        :value="(stat.team * 100) / (stat.team + stat.opponent)"
                        min="0"
                        max="100"
                        class="sidearm-mm-meter --primary --medium"
                        :aria-label="`${schoolName} average for ${stat.title}`"
                      ></meter>
                    </td>
                    <td
                      headers="home success"
                      class="sidearm-mm-game-stats__table-indicator-column border-light-b"
                    >
                      <span
                        v-if="
                          stat.opponent !== null && stat.team > stat.opponent
                        "
                      >
                        <icon size="1.625rem">sf-trophy color --primary</icon>
                        <span class="sr-only">Winner</span> <!-- Add sr-only label for the trophy -->
                      </span>
                      <span
                        v-else-if="stat.opponent !== null && stat.team < stat.opponent"
                      >
                        <span class="sr-only">Unsuccessful</span>
                      </span>
                    </td>
                  </tr>
                  <tr
                    v-if="stat.opponent !== null"
                    :key="stat.title + '_opponent'"
                    class="border-none"
                  >
                    <th id="opponent" :rowspan="1" class="is-hidden border-light-b">
                      {{ opponentName }}
                    </th>
                    <td headers="opponent number" class="no-padding border-light-b">
                      {{ stat.opponent }}
                    </td>
                    <td headers="opponent progress" class="no-padding w-40 border-light-b">
                      <meter
                        :value="
                          (stat.opponent * 100) / (stat.team + stat.opponent)
                        "
                        min="0"
                        max="100"
                        class="sidearm-mm-meter --secondary --medium"
                        :aria-label="`${opponentName} average for ${stat.title}`"
                      ></meter>
                    </td>
                    <td headers="opponent success" class="sidearm-mm-game-stats__table-indicator-column border-light-b"> <!-- Add unsuccessful sr-only text and headers -->
                      <span
                        v-if="
                          stat.opponent > stat.team
                        "
                      >
                        <icon size="1.625rem">sf-trophy color --primary</icon>
                        <span class="sr-only">Winner</span> <!-- Add sr-only label for the trophy -->
                      </span>
                      <span
                        v-else
                      >
                        <span class="sr-only">Unsuccessful</span>
                      </span>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </tab>

        <tab name="Player Stats" key="1">
          <div
            v-set-normal-scroll
            class="sidearm-mm-game-stats__player-stats h-100 overflow-auto"
          >
            <div class="flex flex-justify-between flex-wrap flex-align-center">
              <ul
                class="sidearm-mm-game-stats__player-stats__stat-filters reset flex flex-align-center"
              >
                <li
                  v-for="stat in stat_filters"
                  :key="stat.abbreviation"
                  :class="{
                    'is-toggled': stat.abbreviation === active_stat.abbreviation
                  }"
                  class="flex flex-align-center"
                >
                  <button
                    :class="{
                      'is-toggled':
                        stat.abbreviation === active_stat.abbreviation
                    }"
                    :aria-label="
                      `Toggle stat leaders in ${stat.title.toLowerCase()}`
                    "
                    type="button"
                    @click="change_active_stat(stat)"
                  >
                    <abbr
                      :title="stat.name"
                      class="text-uppercase text-bold text-decoration-none"
                      >{{ stat.abbreviation }}</abbr
                    >
                  </button>
                </li>
              </ul>
              <div
                class="type-paragraph sidearm-mm-game-stats__table-title text-bold pr-2 py-1"
                :class="{ 'is-changing': stat_is_changing }"
              >
                {{ active_stat.title }}
              </div>
            </div>

            <table
              class="sidearm-mm-table sidearm-mm-game-stats__table mt-2"
              :class="{ 'is-changing': stat_is_changing }"
              v-if="sorted_players && sorted_players.length"
            >
              <thead class="is-hidden">
                <tr class="border-none">
                  <th scope="col">Player</th>
                  <th scope="col">Name</th>
                  <th scope="col">Position</th>
                  <th scope="col">Stat Value</th>
                  <th scope="col">Player Details</th>
                </tr>
              </thead>

              <tbody>
                <tr
                  v-for="player in sorted_players"
                  :key="player.rp_id"
                  class="sidearm-mm-game-stats__player-stats__tr relative"
                >
                  <th scope="row" style="width: 132px">
                    <div
                      class="sidearm-mm-game-stats__player-stats__player-image-container pa-1 relative"
                    >
                      <img
                        :src="
                          player && player.image && player.image.url
                            ? `${$root.absolutize_cdn(
                                player.image.url
                              )}?width=120&height=120&mode=crop&format=jpg&quality=80&anchor=topcenter`
                            : player.is_opponent
                            ? round.game.opponent &&
                              round.game.opponent.image &&
                              round.game.opponent.image.url
                              ? `${$root.absolutize_cdn(
                                  round.game.opponent.image.url
                                )}?width=120&height=120`
                              : `${$root.school_logo(120, 120)}&s.grayscale=100`
                            : $root.school_logo(120, 120)
                        "
                        :alt="
                          player.is_opponent
                            ? game.opponent && game.opponent.title
                              ? game.opponent.title
                              : 'Opponent Logo'
                            : $root.data.school.name
                            ? $root.data.school.name
                            : 'School Logo'
                        "
                      />
                    </div>
                  </th>
                  <td>
                    <div
                      class="sidearm-mm-game-stats__player-stats__player-name type-paragraph"
                    >
                      <span>{{ player.first_name }} </span>
                      <span class="text-bold"> {{ player.last_name }}</span>
                    </div>
                  </td>
                  <td class="shrink text-right">
                    {{
                      player.position_long
                        ? player.position_long
                        : player.position_short
                    }}
                  </td>

                  <td class="shrink type-hero-small-plain">
                    {{ player.cumestats[active_stat.individual_stat_key] }}
                  </td>

                  <td colspan="3" class="no-padding">
                    <button
                      @click="open_player_card(player, 2)"
                      class="sidearm-mm-game-stats__player-stats__player-card-toggle"
                    >
                      <span class="type-hero-small-plain mx-4"
                        >View Player Card</span
                      >
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>

            <player-card
              v-model="player_card_open"
              :player-id="player_card_player_id"
              :team-id="player_card_team_id"
              :player="player_card_player"
            >
              <ul
                class="sidearm-mm-player-card__roster reset flex flex-column flex-align-end flex-justify-start"
              >
                <li
                  v-for="player in sorted_players"
                  :key="player.rp_id"
                  class="sidearm-mm-player-card__roster-player my-2 flex flex-align-center"
                  :class="{ active: player.rp_id === player_card_player.rp_id }"
                >
                  <button
                    type="button"
                    :aria-label="'Toggle stats for ' + player.name"
                    class="sidearm-mm-player-card__roster-player-toggle"
                    @click="open_player_card(player, 2)"
                  >
                    <img
                      :src="
                        player && player.image && player.image.url
                          ? player.image.url +
                            '?width=60&height=60&mode=crop&format=jpg&quality=80&anchor=topcenter'
                          : player.is_opponent
                          ? round.game.opponent &&
                            round.game.opponent.image &&
                            round.game.opponent.image.url
                            ? `${$root.absolutize_cdn(
                                round.game.opponent.image.url
                              )}?width=60&height=60`
                            : `${$root.school_logo(60, 60)}&s.grayscale=100`
                          : $root.school_logo(60, 60)
                      "
                      :alt="
                        player.is_opponent
                          ? game.opponent && game.opponent.title
                            ? game.opponent.title
                            : 'Opponent Logo'
                          : $root.data.school.name
                          ? $root.data.school.name
                          : 'School Logo'
                      "
                    />
                  </button>
                </li>
              </ul>
            </player-card>
          </div>
        </tab>

        <tab
          v-if="
            $root.data &&
              $root.data.history_section &&
              $root.data.history_section.items &&
              $root.data.history_section.items.length > 0
          "
          name="History"
          key="2"
        >
          <div v-set-normal-scroll class="h-100 overflow-auto">
            <table class="sidearm-mm-table">
              <thead>
                <tr>
                  <th scope="col">Tournament History</th>
                  <th
                    scope="col"
                    aria-label="Tournament History Fact"
                    class="text-center"
                  >
                    <div>
                      <img
                        :src="$root.school_logo(36, 36)"
                        :alt="
                          $root.data.school.name
                            ? $root.data.school.name
                            : 'School Logo'
                        "
                      />
                    </div>
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr
                  v-for="(item, item_index) in $root.data.history_section.items"
                  :key="item_index"
                >
                  <th scope="row">{{ item.title }}</th>
                  <td class="text-center">{{ item.value }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </tab>
      </tabs>
    </div>
  </div>
</template>

<script>
import CircleChart from "@/components/CircleChart";
import PlayerCard from "@/components/PlayerCard";
import Tabs from "@/components/Tabs/Tabs";
import Tab from "@/components/Tabs/Tab";
import { sort_by } from "@/helpers.js";

export default {
  props: {
    round: { type: Object, required: true }
  },

  components: {
    CircleChart,
    PlayerCard,
    Tabs,
    Tab
  },

  data: () => ({
    active_tab: 0,

    include_team_in_player_stats: true,

    include_opponents_in_player_stats: true,

    player_card_open: false,

    player_card_player_id: 0,

    player_card_player: {},

    player_card_team_id: 0,

    stat_is_changing: false,

    stat_filters: [
      {
        title: "Points Per Game",
        abbreviation: "pts",
        individual_stat_key: "points_per_game",
        overall_stat_key: "our_points_per_game"
      },
      {
        title: "Rebounds Per Game",
        abbreviation: "reb",
        individual_stat_key: "rebounds_per_game",
        overall_stat_key: "our_rebounds_per_game"
      },
      {
        title: "Assists Per Game",
        abbreviation: "ast",
        individual_stat_key: "assists_per_game",
        overall_stat_key: "our_assists_per_game"
      },
      {
        title: "Steals Per Game",
        abbreviation: "stl",
        individual_stat_key: "steals_per_game",
        overall_stat_key: "our_steals_per_game"
      },
      {
        title: "Blocks Per Game",
        abbreviation: "blk",
        individual_stat_key: "blocks_per_game",
        overall_stat_key: "our_blocks_per_game"
      }
    ],

    active_stat: null
  }),
  methods: {
    open_player_card(player, team_id) {
      this.player_card_player = player;
      this.player_card_team_id = team_id;
      this.player_card_open = true;
    },

    change_active_stat(stat) {
      this.stat_is_changing = true;
      this.$nextTick(() => {
        this.stat_is_changing = false;
        this.active_stat = stat;
      });
    },
  },

  computed: {
    schoolName() {
      return this.$root.data.school.name;
    },
    opponentName() {
      const name = this.game?.opponent?.title;
      return name ? this.$root.shorten_name(name) : "Opponent"
    },
    game() {
      if (!this.round) {
        return null;
      }
      return this.round.game;
    },
    team_stats() {
      if (!this.$root.data || !this.$root.cumestats_overall) {
        return null;
      }

      return this.stat_filters.map(stat => ({
        title: stat.title,
        team: Number(this.$root.cumestats_overall[stat.overall_stat_key]),
        opponent:
          this.round && this.round.opponent_stats.team_stats
            ? Number(
                this.round.opponent_stats.team_stats[stat.overall_stat_key]
              )
            : null
      }));
    },

    opponent_roster_with_stats() {
      if (
        !this.round.opponent_roster.length ||
        !this.round.opponent_stats.individual_stats
      ) {
        return [];
      }

      let roster_without_stats = this.round.opponent_roster.slice();
      let cumestats_without_roster = this.round.opponent_stats.individual_stats.slice();

      let roster_combined = roster_without_stats.map(player => {
        let cumestats_index = cumestats_without_roster.findIndex(
          stats => parseInt(stats.player_roster_bio_id) === player.rp_id
        );
        let matched_cumestats = false;
        if (cumestats_index > -1) {
          matched_cumestats = cumestats_without_roster.splice(
            cumestats_index,
            1
          );
        }
        player.cumestats = matched_cumestats ? matched_cumestats[0] : null;
        player.is_opponent = true;
        player.team =
          this.game && this.game.opponent ? this.game.opponent : null;
        return player;
      });
      return roster_combined;
    },

    sorted_players() {
      if (!this.$root.data) {
        return [];
      }

      let players = [];

      if (this.include_team_in_player_stats && this.$root.roster_with_stats) {
        players = players.concat(this.$root.roster_with_stats);
      }

      if (
        this.include_opponents_in_player_stats &&
        this.opponent_roster_with_stats.length
      ) {
        players = players.concat(this.opponent_roster_with_stats);
      }

      return players
        .filter(player => player.cumestats)
        .sort(
          sort_by(`cumestats.${this.active_stat.individual_stat_key}`, "number")
        )
        .reverse()
        .slice(0, 5);
    },
  },
  created() {
    this.active_stat = this.stat_filters[0];
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
.#{$prefix}-game-stats {
  &__details {
    padding: grid_percent(120);
  }

  &__tabs-container {
    padding: grid_percent(120);
  }

  &__tabs {
    max-height: 100%;
  }

  &__legend-key {
    display: block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    overflow: hidden;
    background: var(--primary-background);
    &--opponent {
      background: #d1d1d1;
    }
  }

  &__table,
  &__table-title {
    opacity: 1;
    transition: opacity 0.3s 0.2s;
    &.is-changing {
      opacity: 0;
      transition: opacity 0s 0s;
    }
  }

  &__table-indicator-column {
    width: $spacer * 4 + 6;
  }

  &__player-stats {
    thead {
      display: none;
    }
  }

  &__player-stats__stat-filters {
    li {
      &:not(:last-child) {
        &::after {
          border-top: 1px dashed $stroke-on-light;
          content: "";
          display: block;
          height: 1px;
          width: $spacer * 4;
        }
      }
    }

    button {
      @include base-reset();

      border-radius: 50%;
      border: 1px dashed $stroke-on-light;
      color: $text-on-light;
      height: 3rem;
      line-height: 3rem;
      width: 3rem;

      &.is-toggled {
        border-color: $color-black;
        color: $color-black;
      }
    }
  }

  &__player-stats__tr {
    transition: 0.35s;

    &:hover {
      background-color: $color-primary;
      color: $text-on-primary;

      td:nth-child(n + 2) {
        display: none;
      }

      td:last-child {
        display: table-cell;
      }
    }

    th:first-child {
      padding-top: $spacer !important;
      padding-bottom: $spacer !important;
    }

    td:last-child {
      display: none;
    }
  }

  &__player-stats__player-image-container {
    border: 1px dashed $stroke-on-light;
    border-radius: 50%;
    width: 84px;
    height: 84px;

    &::after {
      border-top: 1px dashed $stroke-on-light;
      content: "";
      display: block;
      height: 1px;
      left: 100%;
      position: absolute;
      top: 50%;
      width: $spacer * 2;
    }

    img {
      border-radius: 50%;
    }
  }

  &__player-stats__player-card-toggle {
    @include base-reset();

    align-items: center;
    display: flex;
    width: 100%;

    &::before,
    &::after {
      @include flex-item(1 1 0px);

      border-top: 1px dashed $text-on-primary;
      content: "";
      display: block;
      height: 1px;
    }

    &::after {
      @include flex-item(1 1 $spacer * 4);
    }
  }
}

.slide-fade-enter-active {
  transition: all 0.4s ease;
}
.slide-fade-leave-active {
  transition: all 0.4s ease;
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(10px);
  opacity: 0;
}

.fade-enter-active {
  transition: opacity 0.4s 0.4s, transform 0.4s 0.4s;
}
.fade-enter {
  opacity: 0;
  transform: translateY(10px);
}
.fade-leave {
  display: none;
}
</style>

<style lang="scss">
.#{$prefix}-game-stats {
  &__tabs {
    > header {
      @include flex-item(0 0 auto);

      margin-bottom: $spacer * 2 !important;
    }

    > div {
      @include flex-item(1 1 0px);
    }
  }
}
</style>
